import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { LocalStorageKeys } from 'src/app/enum/local-storage-keys.enum';

/**
 * Servicio específico para limpiar datos de autenticación
 */
@Injectable({
  providedIn: 'root',
})
export class TokenCleanupService {
  constructor(private localStorageService: LocalStorageService) {}

  /**
   * Limpia todos los tokens y datos relacionados con autenticación
   */
  clearAuthenticationData(): void {
    const authKeys = [
      LocalStorageKeys.ACCESSTOKEN,
      LocalStorageKeys.IDTOKEN,
      LocalStorageKeys.TOKENTIMESTAMP,
      LocalStorageKeys.TOKENEXPIRATION,
    ];

    authKeys.forEach((key) => {
      this.localStorageService.remove(key);
    });

    // También limpia datos de MSAL del localStorage
    this.clearMsalCache();
  }

  /**
   * Limpia el cache de MSAL
   */
  private clearMsalCache(): void {
    const msalKeys = Object.keys(localStorage).filter((key) =>
      key.startsWith('msal.')
    );

    msalKeys.forEach((key) => {
      localStorage.removeItem(key);
    });
  }

  /**
   * Verifica si hay datos de autenticación
   */
  hasAuthenticationData(): boolean {
    return !!this.localStorageService.get(LocalStorageKeys.ACCESSTOKEN);
  }
}
